import LayoutComponent from 'components/layout/layout-component';
import { getPage } from 'lib/db/pages';
import { Page } from 'lib/db/types';
import { sanitizeContent } from 'lib/utils/sanitize-content';
import { GetStaticProps } from 'next';
import { NextSeo } from 'next-seo';

const ImprintPage = ({ page }: { page: Page }) => {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_URL}/imprint`;

  const { content, title, yoast_head_json: seo } = page || {};

  const imprint = sanitizeContent(`${content.rendered}`);

  const SEO = {
    title: seo?.title || title.rendered || '',
    description: seo?.description || imprint || '',
    openGraph: {
      type: seo?.og_type || '',
      url: pageUrl,
      site_name: seo?.og_site_name || '',
      title: seo?.og_title || title.rendered || '',
      description: seo?.og_description || imprint || '',
    },
    canonicalUrl: pageUrl,
  };

  return (
    <LayoutComponent>
      <NextSeo {...SEO} />
      <div
        className="prose mx-auto mb-12 px-4 md:container prose-headings:my-12 prose-headings:text-center prose-headings:font-title prose-headings:text-5xl prose-a:break-all sm:w-full md:px-0"
        dangerouslySetInnerHTML={{ __html: imprint }}
      />
    </LayoutComponent>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  try {
    const page = await getPage({ slug: 'imprint' });

    if (!page) {
      return { notFound: true };
    }

    return {
      props: {
        page,
      },
      revalidate: 600,
    };
  } catch {
    return { notFound: true };
  }
};

export default ImprintPage;
